import React, { Component } from 'react';

class EmptySheet extends Component {
    render() {
        return (
            <li className="sheet-component-container">
                <div className="empty w-100 h-100"></div>
            </li>
        );
    }
}

export default EmptySheet;